/**
 * How far back the in-app inbox (bell panel, notification center, unread badge) reaches. Older notifications are
 * kept in the database but are no longer listed or counted. The backend applies the window; the frontend only uses
 * this number to tell the user where the list ends.
 */
export const NOTIFICATION_INBOX_WINDOW_DAYS = 30;
